import { Directive } from '@angular/core';
import { LcsMultiSelectTriggerComponent } from '@lcs/shared/multi-select';

import { entityMultiSelectText } from 'src/app/common-components/multi-select/entity-multi-select-text-content';
import { RoleOption } from 'src/app/pages/role-register/models/role-option.interface';

@Directive({
    selector: 'lcs-multi-select-trigger[ndtRoleMultiSelect]',
    standalone: false
})
export class RoleMultiSelectTriggerDirective {
   constructor(trigger: LcsMultiSelectTriggerComponent<RoleOption>) {
      trigger.getTextContent = entityMultiSelectText(trigger, 'role');
   }
}
